import { TransferPurchaseInfo } from './transferPurchaseInfo.model'

export interface TpiModalInput {
  tpiDataMap: { [key: number]: TransferPurchaseInfo }
}

export const tpiFieldMap = new Map<string, string>([
  ['basisId', 'Basis Id'],
  ['amortStartDate', 'Amort Start Date'],
  ['amortStartPrice', 'Amort Start Price'],
  ['amortStartYield', 'Amort Start Yield'],
  ['accruedMarketDiscount', 'Accrued Market Discount'],
  ['accumulatedOtti', 'Accumulated OTTI'],
  ['amortOverride', 'Amort Override'],
  ['amortStartCost', 'Amort Start Cost'],
  ['amortTargetDate', 'Amort Target Date'],
  ['amortTargetPrice', 'Amort Target Price'],
  ['origTradeDate', 'Original Trade Date'],
  ['origSettleDate', 'Original Settle Date'],
  ['origPrice', 'Original Price'],
  ['origYield', 'Original Yield'],
  ['commission', 'Commission'],
  ['daysImpaired', 'Days Impaired'],
  ['factor', 'Factor'],
  ['fxAccruedAtLoad', 'FX Accrued At Load'],
  ['fxAccruedMarketDiscount', 'FX Accrued Market Discount'],
  ['fxAccumulatedOtti', 'FX Accumulated OTTI'],
  ['fxBookValueAtLoad', 'FX Book Value at Load'],
  ['fxOrigCost', 'FX Orig Cost'],
  ['fxRateAtOrigEntry', 'FX Rate at Orig Entry'],
  ['fxWashSaleDeferredLoss', 'FX Wash-Sale Deferred Loss'],
  ['localAccruedAtLoad', 'Local Accrued At Load'],
  ['origAccruedInt', 'Orig Accrued Int'],
  ['origCost', 'Orig Cost'],
  ['taxDaysHeld', 'Tax Days Held'],
  ['valuationDate', 'Valuation Date'],
  ['washSaleDeferredLoss', 'Wash-Sale Deferred Loss'],
  ['originalOriginationFee', 'Original Origination Fee'],
  ['straddleDeferredLoss', 'Straddle Deferred Loss'],
  ['fxStraddleDeferredLoss', 'Fx Straddle Deferred Loss'],
  ['section1256DeferredLoss', 'Section 1256 Deferred Loss'],
  ['fxSection1256DeferredLoss', 'Fx Section 1256 Deferred Loss'],
  ['isCapitalize', 'Capitalized'],
  ['prepaidInterest', 'Loan Prepaid Interest'],
  ['interestDue', 'Loan Past Due Interest'],
  ['exitFee', 'Loan Exit Fee'],
  ['exitFeeReceivable', 'Loan Exit Fee Receivable'],
  ['drawFee', 'Loan Draw Fee'],
  ['prepaymentPenaltyFee', 'Loan Prepayment Penalty Fee'],
  ['delinquencyFee', 'Loan Delinquency Fee'],
  ['modificationFee', 'Loan Modification Fee'],
  ['miscellaneousFee', 'Loan Miscellaneous Fee'],
  ['lpCumulativeEarnings', 'LP Cumulative Earnings'],
  ['lpCumulativeDistributions', 'LP Cumulative Distributions'],
  ['returnOfInvestment', 'Return of Investment'],
  ['returnOnInvestment', 'Return on Investment'],
])
